import React from "react";

export const VerticalDotsIcon = (props) => {
  return (
    <>
      <svg
        onClick={props?.onClick}
        width="10"
        height="16"
        viewBox="0 0 4 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.80078 13.4002C3.80078 14.3947 2.99528 15.2002 2.00078 15.2002C1.00628 15.2002 0.200781 14.3947 0.200781 13.4002C0.200781 12.4057 1.00628 11.6002 2.00078 11.6002C2.99528 11.6002 3.80078 12.4057 3.80078 13.4002ZM3.80078 2.6002C3.80078 3.5947 2.99528 4.4002 2.00078 4.4002C1.00628 4.4002 0.200781 3.5947 0.200781 2.6002C0.200781 1.6057 1.00628 0.800196 2.00078 0.800196C2.99528 0.800196 3.80078 1.6057 3.80078 2.6002ZM3.80078 8.0002C3.80078 8.9947 2.99528 9.8002 2.00078 9.8002C1.00628 9.8002 0.200781 8.9947 0.200781 8.0002C0.200781 7.0057 1.00628 6.2002 2.00078 6.2002C2.99528 6.2002 3.80078 7.0057 3.80078 8.0002Z"
          fill="#231F20"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
